<p-card>
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 my-2 col-12">
            <p-messages *ngIf="employes.length === 0" severity="warn">
                <ng-template pTemplate>
                    <div class="ml-2">
                        <p>
                            <b>Attention</b> : La liste des destinataire est vide, vous pouvez en ajouter en ajoutant des personnes comme membre de l'emplacement et en leur attribuant "Réception de rapports journaliers"
                        </p>
                        <div class="flex justify-content-end">
                            <p-button label="Aller dans l'emplacement" icon="pi pi-arrow-right" (onClick)="allerDansEmplacement()" 
                                styleClass="p-button-text"></p-button>
                        </div>
                    </div>
                </ng-template>
            </p-messages>
            <p-table *ngIf="employes.length > 0" [value]="employes" [(selection)]="selection" dataKey="employeId">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 4rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th>Nom</th>
                        <th>Prénom</th>
                        <th>Courriel</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-employe>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="employe"></p-tableCheckbox>
                        </td>
                        <td>{{employe.nom}}</td>
                        <td>{{employe.prenom}}</td>
                        <td>{{employe.courriel}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div class="flex flex-column gap-2 my-2 col-12">
            <h5 class="m-0">Autres destinataires</h5>
            <small class="m-0">Entrez les adresses courriel des destinataires supplémentaires <b>(appuyez sur Entrée pour ajouter)</b></small>
            <p-chips [(ngModel)]="autreCourriels" [style]="{'width':'100%'}" />
        </div>
    </div>

    <div class="flex justify-content-end gap-2 mt-4">
        <p-button label="Annuler" icon="pi pi-times" (onClick)="Annuler()" 
            styleClass="p-button-text"></p-button>
        <p-button label="Envoyer" icon="pi pi-send" (onClick)="Envoyer()" 
            styleClass="p-button-primary"></p-button>
    </div>
</p-card> 